export const TOURNAMENT_LOAD_CONTEST_LEADERBOARD = 'TOURNAMENT_LOAD_CONTEST_LEADERBOARD'
export const TOURNAMENT_LOAD_CONTEST_LEADERBOARD_SUCCESS = 'TOURNAMENT_LOAD_CONTEST_LEADERBOARD_SUCCESS'
export const TOURNAMENT_LOAD_CONTEST_LEADERBOARD_FAILURE = 'TOURNAMENT_LOAD_CONTEST_LEADERBOARD_FAILURE'
